import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setType"] = "search/setType";
    ActionTypes["setFrom"] = "search/setFrom";
    ActionTypes["setTo"] = "search/setTo";
    ActionTypes["setDateRange"] = "search/setDateRange";
    ActionTypes["setOccupancyAndCabinClass"] = "search/setOccupancyAndCabinClass";
    ActionTypes["setOccupancy"] = "search/setOccupancy";
    ActionTypes["setCabinClass"] = "search/setCabinClass";
    ActionTypes["setIsDirect"] = "search/setIsDirect";
    ActionTypes["swapFromTo"] = "search/swapFromTo";
    ActionTypes["setInitial"] = "search/setInitial";
    ActionTypes["removeSegment"] = "search/removeSegment";
    ActionTypes["addSegment"] = "search/addSegment";
    ActionTypes["clearSegments"] = "search/clearSegments";
    ActionTypes["resetSegment"] = "search/resetSegment";
    ActionTypes["fareCalendarStart"] = "fareCalendar/start";
    ActionTypes["fareCalendarSuccess"] = "fareCalendar/success";
    ActionTypes["fareCalendarError"] = "fareCalendar/error";
    ActionTypes["fareCalendarClear"] = "fareCalendar/clear";
    ActionTypes["fareCalendarDataCollectionSuccess"] = "fareCalendarDataCollection/success";
    ActionTypes["setRecentSearchHistory"] = "search/setRecentSearchHistory";
    ActionTypes["selectRecentSearch"] = "search/selectRecentSearch";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setType: createAction(ActionTypes.setType, (type) => ({
        payload: { type }
    })),
    removeSegment: createAction(ActionTypes.removeSegment, (searchSegmentIndex) => ({
        payload: { searchSegmentIndex }
    })),
    addSegment: createAction(ActionTypes.addSegment, () => ({
        payload: {}
    })),
    clearSegments: createAction(ActionTypes.clearSegments, () => ({
        payload: {}
    })),
    setFrom: createAction(ActionTypes.setFrom, (from, searchSegmentIndex) => ({
        payload: { from, searchSegmentIndex }
    })),
    setTo: createAction(ActionTypes.setTo, (to, searchSegmentIndex) => ({
        payload: { to, searchSegmentIndex }
    })),
    setDateRange: createAction(ActionTypes.setDateRange, (range, searchSegmentIndex) => ({
        payload: { range, searchSegmentIndex }
    })),
    setOccupancyAndCabinClass: createAction(ActionTypes.setOccupancyAndCabinClass, (data) => ({
        payload: { ...data }
    })),
    setOccupancy: createAction(ActionTypes.setOccupancy, (occupancy) => ({
        payload: { ...occupancy }
    })),
    setCabinClass: createAction(ActionTypes.setCabinClass, (cabinClass) => ({
        payload: { cabinClass }
    })),
    setIsDirect: createAction(ActionTypes.setIsDirect, (isDirect) => ({
        payload: { isDirect }
    })),
    swapFromTo: createAction(ActionTypes.swapFromTo, (searchSegmentIndex) => ({
        payload: { searchSegmentIndex }
    })),
    setInitial: createAction(ActionTypes.setInitial, (initialValues) => ({
        payload: { initialValues }
    })),
    resetSegment: createAction(ActionTypes.resetSegment, (searchSegmentIndex) => ({
        payload: { searchSegmentIndex }
    })),
    fareCalendarStart: createAction(ActionTypes.fareCalendarStart, () => ({
        payload: {}
    })),
    fareCalendarSuccess: createAction(ActionTypes.fareCalendarSuccess, (data, dateRange, departureDate, maxOfferWindowDays) => ({
        payload: { data, dateRange, departureDate, maxOfferWindowDays }
    })),
    fareCalendarError: createAction(ActionTypes.fareCalendarError, (error) => ({
        payload: { error }
    })),
    fareCalendarClear: createAction(ActionTypes.fareCalendarClear, () => ({
        payload: {}
    })),
    fareCalendarDataCollectionSuccess: createAction(ActionTypes.fareCalendarDataCollectionSuccess, (prices) => ({
        payload: { prices }
    })),
    setRecentSearchHistory: createAction(ActionTypes.setRecentSearchHistory, (recentSearchHistory) => ({
        payload: { recentSearchHistory }
    })),
    selectRecentSearch: createAction(ActionTypes.selectRecentSearch, (search) => ({
        payload: { search }
    }))
};
